import { Box, Icon, Text, dimensions } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  subtitle: string
  compact?: boolean
}

export const EmptyState = ({ title, subtitle, compact }: Props) => {
  return (
    <Box
      textAlign="center"
      paddingBottom="s48"
      paddingTop="s48"
      style={{ transform: `translateY(-${dimensions.s24})` }}
      alignItems="center"
    >
      <Box paddingBottom="s8">
        <Icon.Large icon="fireworks" />
      </Box>
      {compact ? (
        <>
          <Text.Normal size="200">{title}</Text.Normal>
          <Text.Normal size="200">{subtitle}</Text.Normal>
        </>
      ) : (
        <>
          <Box paddingBottom="s4">
            <Text size="300" weight="semibold" color="grey1000">
              {title}
            </Text>
          </Box>
          <Text.Normal size="300">{subtitle}</Text.Normal>
        </>
      )}
    </Box>
  )
}
